const css = `g>text.wDBhVa__highlighted{fill:var(--base-text-emphasized);font-weight:700}`;
document.head
    .appendChild(document.createElement("style"))
    .appendChild(document.createTextNode(css));
export {css};

export default {"highlighted":"wDBhVa__highlighted"};
